import React from 'react';

// Utilities
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';

// Components
import LandingPageCTAButton from 'shared/components/LandingPageCTA/LandingPageCTAButton';
import CopyLinkButton from 'shared/components/LandingPageCTA/CopyLinkButton';

// Icons
import GoogleIcon from 'assets/images/shared/google.svg';
import OutlookIcon from 'assets/images/shared/outlook.svg';
import CalendarIcon from 'assets/images/shared/calendar-plus.svg';

const {
  webinars: {
    CLICK_ADD_TO_CALENDER,
    CLICK_BOOK_SESSION,
    CLICK_WEBINAR_CONFIRMATION_CTA,
  },
} = mixpanelEvents;

export const getPageContent = (webinar = {}, dateTime = '') => ({
  title: (
    <>
      <b>All set!</b> You're now registered for the <b>“{webinar.name}”</b>{' '}
      webinar.
    </>
  ),
  subTitle: (
    <>
      To join the webinar, <b>log into your Bravely account</b> on {dateTime}
      &nbsp;and click the <b>"Join Now"</b> button. You have also been sent a
      confirmation email with a link to directly join the webinar.
    </>
  ),
  buttonProps: {
    textIcon: CalendarIcon,
    text: 'Add to Calendar',
    link: undefined,
    items: [
      {
        label: 'Google',
        icon: GoogleIcon,
        action: () => {
          mixpanelTrack(CLICK_ADD_TO_CALENDER, {
            encodedId: webinar.encodedId,
            name: webinar.name,
            calendarType: 'Google',
          });
          window.open(webinar.googleLink);
        },
      },
      {
        label: 'Outlook',
        icon: OutlookIcon,
        action: () => {
          mixpanelTrack(CLICK_ADD_TO_CALENDER, {
            encodedId: webinar.encodedId,
            name: webinar.name,
            calendarType: 'Outlook',
          });
          window.open(webinar.outlookLink);
        },
      },
    ],
  },
  bookCtaProps: {
    copy: 'Want to get a head start? Schedule a session with a Bravely coach.',
    button: {
      component: LandingPageCTAButton,
      props: {
        text: 'Book a Session',
        link: '/book',
        onClick: () => {
          mixpanelTrack(CLICK_WEBINAR_CONFIRMATION_CTA, {
            encodedId: webinar.encodedId,
            name: webinar.name,
            CTA: 'Book a Session',
          });
        },
      },
    },
  },
  shareCtaProps: {
    copy:
      'Have a coworker who would love this webinar? Share the registration link with them!',
    button: {
      component: CopyLinkButton,
      props: {
        text: 'Copy Link',
        link: `${location.origin}/webinars/${webinar?.encodedId}`,
        onClick: () => {
          mixpanelTrack(CLICK_WEBINAR_CONFIRMATION_CTA, {
            encodedId: webinar.encodedId,
            name: webinar.name,
            CTA: 'Copy Link',
          });
        },
      },
    },
  },
});
